import { makeGetRequest, makePostRequest } from "../helpers"

export const getPatientLoyaltyCard = async (patientId: string, cardId: string) => {
    const { data } = await makeGetRequest(`/api/loyalty_cards/${patientId}/${cardId}`);

    return data.result;
}

export const syncPatientLoyaltyCards = async (patientId: string) => {
    return await makePostRequest(`/api/loyalty_cards/${patientId}/sync`, {});
}

export const syncPatientLoyaltyCard = async (patientId: string, cardId: string) => {
    return await makePostRequest(`/api/loyalty_cards/${patientId}/sync/${cardId}`, {});
}